(function () {

    function init() {
        $('div#hpeit-skuPdp-productCTA div.price-cta-section div.col-sm-12.col-md-7.col-lg-8').removeClass('col-sm-12 col-md-7').addClass('col-md-7 col-sm-6');
        $('div.hpeit-skuPdp-requestQuoteCTA').removeClass('pl-1')
    }

    window.feUtils.waitForConditions({
        conditions: ['body' ],
        activity: feProjectId,
        callback: init,
    })

})();
